'use strict';

var DataFilterFactory = function DataFilterFactory() {
  function DataFilter(sourceType, filterType, priority) {
    this.sourceType = sourceType;
    this.filterType = filterType;
    this.priority = priority || 0;
  }
  DataFilter.prototype.canFilter = function (sourceType, filterType) {
    var self = this;
    if (Array.isArray(self.sourceType)) {
      return self.sourceType.indexOf(sourceType) !== -1 && self.filterType === filterType;
    } else {
      return self.sourceType === sourceType && self.filterType === filterType;
    }
  };
  DataFilter.prototype.getFilterType = function () {
    return this.filterType;
  };
  function stripSpacesAndLowerCase(value) {
    return value ? value.replace(/\s/g, '').toLowerCase() : value;
  }
  function getEffectivePropertyValue(element, propertyNames) {
    var fieldValue;
    for (var i = 0, length = propertyNames.length; i < length; i++) {
      if (element[propertyNames[i]]) {
        fieldValue = element[propertyNames[i]];
        break;
      }
    }
    return stripSpacesAndLowerCase(fieldValue);
  }
  function getFilterPropertyValue(element, filterPropertyName) {
    var fieldValue = element[filterPropertyName];
    if (filterPropertyName === 'season' || filterPropertyName === 'seasonOverride') {
      fieldValue = stripSpacesAndLowerCase(fieldValue);
    }
    return fieldValue;
  }
  function comparator(element, filterPropertyNames, value) {
    if (Array.isArray(filterPropertyNames)) {
      return getEffectivePropertyValue(element, filterPropertyNames) === value;
    } else {
      return getFilterPropertyValue(element, filterPropertyNames) === value;
    }
  }
  function rangeComparator(filterMap, element, filterPropertyNames) {
    if (Array.isArray(filterPropertyNames)) {
      return filterMap[getEffectivePropertyValue(element, filterPropertyNames)];
    } else {
      return filterMap[getFilterPropertyValue(element, filterPropertyNames)];
    }
  }
  function filterByOneValue(data, value, filterPropertyName) {
    var result = [];
    var i, length, element;
    for (i = 0, length = data.length; i < length; i++) {
      element = data[i];
      if (comparator(element, filterPropertyName, value)) {
        result.push(element);
      }
    }
    return result;
  }
  function filterByRange(data, range, filterPropertyNames) {
    var result = [];
    var i, length, element;
    var filterMap = {};
    for (var s = 0; s < range.length; s++) {
      filterMap[range[s]] = true;
    }
    for (i = 0, length = data.length; i < length; i++) {
      element = data[i];
      if (rangeComparator(filterMap, element, filterPropertyNames) === true) {
        result.push(element);
      }
    }
    return result;
  }
  DataFilter.prototype.filter = function (data, range, groupBy) {
    groupBy = groupBy || this.groupBy;
    var result = [];
    if (Array.isArray(range)) {
      if (range.length === 1) {
        var value = range[0];
        result = filterByOneValue(data, value, groupBy);
      } else if (range.length > 1) {
        result = filterByRange(data, range, groupBy);
      }
    }
    return result;
  };
  return DataFilter;
};
module.exports = DataFilterFactory;